import {
    RegionsEnum, SensorAccessoriesPageAmDocument,
    SensorAccessoriesPageAmQuery, SensorAccessoriesPageAmQueryVariables, SensorAccessoriesPageApDocument,
    SensorAccessoriesPageApQuery, SensorAccessoriesPageApQueryVariables, SensorAccessoriesPageEuDocument,
    SensorAccessoriesPageEuQuery,
    SensorAccessoriesPageEuQueryVariables,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getSensorsPageConfig } from 'src/sensors/list/SensorsPageMapping.ts';

export type SensorsAccessoriesPageData = Omit<
SensorAccessoriesPageEuQuery | SensorAccessoriesPageApQuery | SensorAccessoriesPageAmQuery,
'__typename'
>;
export type SensorsAccessoriesPageVariables = Omit<
SensorAccessoriesPageEuQueryVariables | SensorAccessoriesPageApQueryVariables | SensorAccessoriesPageAmQueryVariables,
'__typename'
>;

export type SensorsAccessoriesPageConfig = {
    query: DocumentNode;
    filterConfig: FilterConfig;
}

export const getSensorsAccessoriesPageConfig = (region: RegionsEnum): SensorsAccessoriesPageConfig | null => {
    const sensorsPageConfig = getSensorsPageConfig(region);
    if (sensorsPageConfig === null) {
        throw new Error('No Sensors Page Config');
    }
    const {
        filterConfig,
    } = sensorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(SensorAccessoriesPageEuDocument),
            filterConfig,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(SensorAccessoriesPageApDocument),
            filterConfig,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(SensorAccessoriesPageAmDocument),
            filterConfig,
        };
    }
    return null;
};
